var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRangoAccion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 465.216,
    height: 455.614,
    viewBox: "0 0 465.216 455.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#519390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_532",
    "data-name": "Grupo 532",
    transform: "translate(9059.058 17716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_610",
    "data-name": "Trazado 610",
    d: "M649.891,185.664H410.608c-1.9,0-3.436,4.151-3.437,9.266V632.009c0,5.116,1.54,9.261,3.437,9.266H649.891c1.006,0,1.962-1.189,2.614-3.252.027-.08.053-.165.075-.255a15.885,15.885,0,0,0,.493-2.242,22.953,22.953,0,0,0,.26-3.517V194.93C653.33,189.811,651.79,185.664,649.891,185.664Zm2.46,446.345a15.519,15.519,0,0,1-.406,3.634,6.855,6.855,0,0,1-.93,2.253,1.454,1.454,0,0,1-1.124.733H410.608c-1.356,0-2.454-2.966-2.456-6.62V194.93c0-3.654,1.1-6.616,2.456-6.62H649.891c1.358,0,2.458,2.963,2.46,6.621Z",
    transform: "translate(-9319.112 -17901.664)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_695",
    "data-name": "Trazado 695",
    transform: "translate(-8809.574 -17472.66)",
    fill: "#faf8f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 171.0812377929688 184.3965606689453 L 23.98458099365234 184.3965606689453 C 20.81410598754883 184.3965606689453 17.73873138427734 183.7742614746094 14.84385585784912 182.5469818115234 C 12.04743099212646 181.3614044189453 9.535855293273926 179.6640625 7.378880500793457 177.5020599365234 C 5.221855640411377 175.3399505615234 3.528380632400513 172.8223571777344 2.345505475997925 170.0191802978516 C 1.120930552482605 167.1171875 0.5000056028366089 164.0341796875 0.5000056028366089 160.8558349609375 L 0.5000056028366089 24.04075622558594 C 0.5000056028366089 20.86240577697754 1.120930552482605 17.77940559387207 2.345505475997925 14.87740516662598 C 3.528380632400513 12.0742301940918 5.221855640411377 9.556605339050293 7.378880500793457 7.394530296325684 C 9.535855293273926 5.232505321502686 12.04743099212646 3.535155296325684 14.84385585784912 2.34958028793335 C 17.73873138427734 1.122305393218994 20.81410598754883 0.500005304813385 23.98458099365234 0.500005304813385 L 171.0812377929688 0.500005304813385 C 174.251708984375 0.500005304813385 177.3270874023438 1.122305393218994 180.2219543457031 2.34958028793335 C 183.0183868408203 3.535155296325684 185.5299530029297 5.232505321502686 187.6869354248047 7.394530296325684 C 189.8439483642578 9.556605339050293 191.5374298095703 12.0742301940918 192.7203063964844 14.87740516662598 C 193.9448852539062 17.77940559387207 194.5658111572266 20.86240577697754 194.5658111572266 24.04075622558594 L 194.5658111572266 160.8558349609375 C 194.5658111572266 164.0341796875 193.9448852539062 167.1171875 192.7203063964844 170.0191802978516 C 191.5374298095703 172.8223571777344 189.8439483642578 175.3399505615234 187.6869354248047 177.5020599365234 C 185.5299530029297 179.6640625 183.0183868408203 181.3614044189453 180.2219543457031 182.5469818115234 C 177.3270874023438 183.7742614746094 174.251708984375 184.3965606689453 171.0812377929688 184.3965606689453 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.98457336425781 1 C 20.88153076171875 1 17.87181091308594 1.60894775390625 15.03903198242188 2.8099365234375 C 12.30220031738281 3.970199584960938 9.84405517578125 5.631500244140625 7.73284912109375 7.747650146484375 C 5.621475219726562 9.863983154296875 3.963912963867188 12.32818603515625 2.80615234375 15.07180786132812 C 1.607681274414062 17.91195678710938 1 20.92955017089844 1 24.04078674316406 L 1 160.8558349609375 C 1 163.9670257568359 1.607681274414062 166.9846343994141 2.80615234375 169.8247833251953 C 3.963912963867188 172.5684051513672 5.621475219726562 175.0326080322266 7.73284912109375 177.1489105224609 C 9.84405517578125 179.2650604248047 12.30220031738281 180.9263610839844 15.03903198242188 182.0866241455078 C 17.87181091308594 183.28759765625 20.88153076171875 183.8965606689453 23.98457336425781 183.8965606689453 L 171.0812377929688 183.8965606689453 C 174.1842803955078 183.8965606689453 177.1940002441406 183.28759765625 180.0267791748047 182.0866241455078 C 182.7636108398438 180.9263610839844 185.2217559814453 179.2650604248047 187.3329620361328 177.1489105224609 C 189.4443359375 175.0326080322266 191.1018981933594 172.5684051513672 192.2596588134766 169.8247833251953 C 193.4581298828125 166.9846343994141 194.0658111572266 163.9670257568359 194.0658111572266 160.8558349609375 L 194.0658111572266 24.04078674316406 C 194.0658111572266 20.92955017089844 193.4581298828125 17.91195678710938 192.2596588134766 15.07180786132812 C 191.1018981933594 12.32818603515625 189.4443359375 9.863983154296875 187.3329620361328 7.747650146484375 C 185.2217559814453 5.631500244140625 182.7636108398438 3.970199584960938 180.0267791748047 2.8099365234375 C 177.1940002441406 1.60894775390625 174.1842803955078 1 171.0812377929688 1 L 23.98457336425781 1 M 23.98457336425781 0 L 171.0812377929688 0 C 184.3275604248047 0 195.0658111572266 10.76341247558594 195.0658111572266 24.04078674316406 L 195.0658111572266 160.8558349609375 C 195.0658111572266 174.1331481933594 184.3275604248047 184.8965606689453 171.0812377929688 184.8965606689453 L 23.98457336425781 184.8965606689453 C 10.73825073242188 184.8965606689453 0 174.1331481933594 0 160.8558349609375 L 0 24.04078674316406 C 0 10.76341247558594 10.73825073242188 0 23.98457336425781 0 Z",
    stroke: "none",
    fill: "#221e1d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_259",
    "data-name": "Rect\\xE1ngulo 259",
    width: 244.847,
    height: 2.649,
    transform: "translate(-8910.614 -17678.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_51",
    "data-name": "Elipse 51",
    cx: 7.928,
    cy: 7.947,
    rx: 7.928,
    ry: 7.947,
    transform: "translate(-8897.842 -17704.08)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_52",
    "data-name": "Elipse 52",
    cx: 7.928,
    cy: 7.947,
    rx: 7.928,
    ry: 7.947,
    transform: "translate(-8874.758 -17704.08)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_53",
    "data-name": "Elipse 53",
    cx: 7.928,
    cy: 7.947,
    rx: 7.928,
    ry: 7.947,
    transform: "translate(-8851.678 -17704.08)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_525",
    "data-name": "Grupo 525",
    transform: "translate(-9059.058 -17607.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_627",
    "data-name": "Trazado 627",
    d: "M294.227,343.921V333.482l-40.17-4.967v15.407Z",
    transform: "translate(-59.484 -149.838)",
    fill: "#e9e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_628",
    "data-name": "Trazado 628",
    d: "M0,0H32.808V12.646H12.676A12.661,12.661,0,0,1,0,0H0Z",
    transform: "translate(244.415 163.512) rotate(89.997)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_629",
    "data-name": "Trazado 629",
    d: "M90.755,507.9h10.415l4.954-40.265H90.753Z",
    transform: "translate(-34.904 -170.501)",
    fill: "#e9e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_630",
    "data-name": "Trazado 630",
    d: "M0,0H32.731V12.676H12.646A12.661,12.661,0,0,1,0,0H0Z",
    transform: "translate(86.348 347.091) rotate(179.997)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_631",
    "data-name": "Trazado 631",
    d: "M265.36,655.256c-.124,0-.249-.006-.375-.017L250.8,654.054a4.373,4.373,0,0,1-3.969-4.92l7.361-57.388a2.669,2.669,0,0,0,0-.672l-11.694-92.5a4.374,4.374,0,0,1,4.271-4.927l41.364-.588a5.045,5.045,0,0,1,.63.037l.113.032,7.956,3.452L412.5,509.353a4.39,4.39,0,0,1,3.809,4.342v14.927a4.372,4.372,0,0,1-4.871,4.349l-66.822-7.807a2.575,2.575,0,0,0-1.008.077l-52.842,14.6a2.654,2.654,0,0,0-1.9,2.095l-19.215,109.7A4.358,4.358,0,0,1,265.36,655.256Z",
    transform: "translate(-196.63 -332.366)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_54",
    "data-name": "Elipse 54",
    cx: 28.514,
    cy: 28.581,
    rx: 28.514,
    ry: 28.581,
    transform: "translate(36.826 19.732)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_55",
    "data-name": "Elipse 55",
    cx: 11.799,
    cy: 11.827,
    rx: 11.799,
    ry: 11.827,
    transform: "translate(43.567 6.406)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_632",
    "data-name": "Trazado 632",
    d: "M234.729,316.162A11.817,11.817,0,0,1,245.3,304.4a11.826,11.826,0,1,0,0,23.526A11.818,11.818,0,0,1,234.729,316.162Z",
    transform: "translate(-195.096 -304.335)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 20.864,
    cy: 20.913,
    rx: 20.864,
    ry: 20.913,
    transform: "translate(44.395 36.498)",
    fill: "#e9e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_634",
    "data-name": "Trazado 634",
    d: "M230.608,368.989a8.559,8.559,0,0,1-7.733,10.6l-8.05,29.338L204.43,397.03l9.239-26.036a8.586,8.586,0,0,1,16.94-2.005Z",
    transform: "translate(-190.905 -312.958)",
    fill: "#e9e5e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_57",
    "data-name": "Elipse 57",
    cx: 19.665,
    cy: 11.827,
    rx: 19.665,
    ry: 11.827,
    transform: "translate(48.992 30.427)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_636",
    "data-name": "Trazado 636",
    d: "M334.989,513.793a8.567,8.567,0,0,1-5.479-11.926l-21.663-21.315,15.423-3.322,18.207,20.75a8.607,8.607,0,0,1-6.488,15.812Z",
    transform: "translate(-206.471 -330.014)",
    fill: "#e9e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_531",
    "data-name": "Grupo 531",
    transform: "translate(0 63.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_633",
    "data-name": "Trazado 633",
    d: "M263.868,495.872c-7.083,0-14.962-1.966-23.164-7.447l-.139-.093-.039-.162c-.076-.321-7.623-32.337-7.771-57.134a27.327,27.327,0,0,1,11.213-22.367,26.394,26.394,0,0,1,23.915-4.03h0q.8.253,1.6.543a27.233,27.233,0,0,1,17.558,27.907c-1.076,13.1-1.507,36.965,7.692,49.573l.215.3-.258.258C294.509,483.39,281.715,495.872,263.868,495.872Z",
    transform: "translate(-195.169 -382.965)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_635",
    "data-name": "Trazado 635",
    d: "M196.565,436.161a8.1,8.1,0,0,1-7.588-10.821l15.3-43.1a4.281,4.281,0,0,1,5.1-2.695l11.153,2.959a4.271,4.271,0,0,1,2.9,5.611L213.6,414.687l16.684-5.319a10.871,10.871,0,1,1,4.887,21.119l-37.391,5.583A8.159,8.159,0,0,1,196.565,436.161Z",
    transform: "translate(-188.509 -379.404)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_637",
    "data-name": "Trazado 637",
    d: "M319.918,492.4a3.922,3.922,0,0,1-3.038-1.428l-23.648-28.758-18.509-35.63a11.806,11.806,0,0,1,1.756-10.676,11.28,11.28,0,0,1,9.367-4.607,14.772,14.772,0,0,1,2.73.314,11.316,11.316,0,0,1,8.122,7.112l15.679,36.923,18.791,23.76a3.956,3.956,0,0,1-.613,5.513l-8.177,6.61A3.9,3.9,0,0,1,319.918,492.4Z",
    transform: "translate(-201.4 -384.143)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_530",
    "data-name": "Grupo 530",
    transform: "translate(-8809.05 -17485.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_694",
    "data-name": "Trazado 694",
    transform: "translate(0 37.057)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,113.182v0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 117.1403579711914 C 0 117.1403579711914 0 115.9159393310547 0 113.1817016601562 L 0 23.9999942779541 L 0 117.1403579711914 Z",
    stroke: "none",
    fill: "#221e1d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_67",
    "data-name": "Elipse 67",
    cx: 22.296,
    cy: 22.349,
    rx: 22.296,
    ry: 22.349,
    transform: "translate(170.616 0)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_533",
    "data-name": "Grupo 533",
    transform: "translate(179.605 9.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_659",
    "data-name": "Trazado 659",
    d: "M1053.041,402.622a.967.967,0,0,1-.283-.687V377.2a.969.969,0,1,1,1.939,0v24.735a.969.969,0,0,1-1.655.687Z",
    transform: "translate(-1040.821 -376.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_660",
    "data-name": "Trazado 660",
    d: "M1040.321,390.615a.972.972,0,0,1,.686-1.659h24.677a.972.972,0,0,1,0,1.943h-24.677A.966.966,0,0,1,1040.321,390.615Z",
    transform: "translate(-1040.037 -375.618)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_529",
    "data-name": "Grupo 529",
    transform: "translate(18.858 44.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_656",
    "data-name": "Trazado 656",
    d: "M986.64,459.447H843.621a6.88,6.88,0,0,1,0-13.739H986.64a6.88,6.88,0,0,1,0,13.739Z",
    transform: "translate(-837.12 -332.93)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_657",
    "data-name": "Trazado 657",
    d: "M904.007,427.255H844.873a7.773,7.773,0,0,1,0-15.547h59.134a7.773,7.773,0,0,1,0,15.547Z",
    transform: "translate(-759.108 -380.751)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_66",
    "data-name": "Elipse 66",
    cx: 26.886,
    cy: 26.949,
    rx: 26.886,
    ry: 26.949,
    transform: "translate(0 0)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_691",
    "data-name": "Trazado 691",
    d: "M904.007,427.255H844.873a7.773,7.773,0,0,1,0-15.547h59.134a7.773,7.773,0,0,1,0,15.547Z",
    transform: "translate(-759.108 -405.697)",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_272",
    "data-name": "Rect\\xE1ngulo 272",
    width: 208.848,
    height: 145.58,
    rx: 15,
    transform: "translate(-8896.429 -17649.055)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_692",
    "data-name": "Trazado 692",
    d: "M782.1,406.153v.907H629.184v-.949l.823-1.167,48.48-68.6a2.419,2.419,0,0,1,3.928,0l32.509,46,23.141-32.459a2.419,2.419,0,0,1,3.921,0l39.292,55.109Z",
    transform: "translate(-9497.784 -17910.537)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_73",
    "data-name": "Elipse 73",
    cx: 21.599,
    cy: 21.649,
    rx: 21.599,
    ry: 21.649,
    transform: "translate(-8874.608 -17619.564)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_693",
    "data-name": "Trazado 693",
    d: "M986.64,459.447H843.621a6.88,6.88,0,0,1,0-13.739H986.64a6.88,6.88,0,0,1,0,13.739Z",
    transform: "translate(-9627.08 -17807.225)",
    fill: "#ccc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRangoAccion);
export default __webpack_public_path__ + "static/media/rango_accion.0510723fe780a9486e98a65496fa57ca.svg";
export { ForwardRef as ReactComponent };